import { useCallback, useEffect, useState } from 'react';
import { useGetProductsTypeList } from '../../../hooks/useGetProductTypeList';

import { useGetShopItemsServices } from '../../../hooks/useGetShopItemsServices';
import { useModalParkStore } from '../../../store/park/modalParkStore';
import { useModalServicesStore } from '../../../store/services/modalServicesStore';
import { useModalShoppingStore } from '../../../store/shopping/modalShoppingStore';
import {
    CartValuesServiceStore,
    useShoppingCartStore,
} from '../../../store/shoppingCart/shoppingCartStore';

export function useLogicHome() {
    const [selectedTypeProductId, setSelectedTypeProductId] = useState<
        number | undefined
    >(undefined);
    const [currentCartAddValue, setCurrentCartAddValue] =
        useState<CartValuesServiceStore | null>(null);

    const { isPending: isPendingTypeList } = useGetProductsTypeList();

    const { data: dataShopItems, isPending: isPendingShopItems } =
        useGetShopItemsServices({
            ProductTypeId: selectedTypeProductId,
        });

    // Estados globais
    const { setIsVisiblePark } = useModalParkStore();
    const { setIsVisibleShoppingWave } = useModalShoppingStore();
    const { setIsVisibleServices } = useModalServicesStore();
    const { typesList, setCartValues, setCartIsVisible, setCurrentDate } =
        useShoppingCartStore();

    const handleAddToCart = useCallback(
        (cartCurrentValue: CartValuesServiceStore) => {
            const findTypeName = typesList?.find(
                ({ id }) => id === selectedTypeProductId
            );
            setCartValues(cartCurrentValue);
            setCurrentDate(cartCurrentValue.date);
            setCartIsVisible(true);
            setIsVisibleServices(true, findTypeName?.name);
        },
        [
            typesList,
            setCartValues,
            setIsVisibleServices,
            setCartIsVisible,
            setCurrentDate,
            selectedTypeProductId,
        ]
    );

    //remove overflow quando o currenCartAddValue nao for null tira o overflow y

    useEffect(() => {
        if (currentCartAddValue) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [currentCartAddValue]);

    return {
        selectedTypeProductId,
        dataShopItems,
        dataTypesList: typesList,
        isPendingTypeList,
        isPendingShopItems,
        currentCartAddValue,
        setCurrentCartAddValue,
        handleAddToCart,
        handleOpenPark: setIsVisiblePark,
        handleOpenStore: setIsVisibleShoppingWave,
        setSelectedTypeProductId,
    };
}
